import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { connect } from "react-redux";
import logo1 from "./../assets/images/Header_logo.png";
import { userMasterActions } from "../actions";

class DeleteAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Email: "",
      Password: "",
      eyeToggle: true,
      confirmModal: false,
      formError: {
        Email: "",
        Password: "",
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.passwordToggle = this.passwordToggle.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      this.validateForm(name, value);
    });
  }

  validateForm = () => {
    const errors = {
      Email: "",
      Password: "",
    };

    if (!this.state.Email) {
      errors.Email = "Please enter your email id";
    } else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.Email)
    ) {
      errors.Email = "Please enter valid email id";
    }

    if (!this.state.Password) {
      errors.Password = "Please enter password";
    }

    this.setState({ formError: errors });

    return !errors.Email && !errors.Password;
  };

  passwordToggle() {
    this.setState({ eyeToggle: !this.state.eyeToggle });
  }

  submitForm(event) {
    event.preventDefault();

    if (this.validateForm()) {
      this.setState({ confirmModal: true });
    }
  }

  handleConfirmDelete() {
    const formData = {
      Email: this.state.Email,
      Password: this.state.Password,
    };
    this.props.deleteUser(formData);
    this.setState({
      confirmModal: false,
      Email: "",
      Password: "",
      formError: {
        Email: "",
        Password: "",
      },
    });
  }

  render() {
    return (
      <>
        <section className="body1">
          <div className="login-wrap mt-5 login-page">
            <img src={logo1} className="img-fluid" alt="Logo" />
            <div className="login-html">
              <div className="foot-lnk"></div>

              <input
                id="tab-1"
                type="radio"
                name="tab"
                className="sign-in"
                defaultChecked
              />
              <label
                htmlFor="tab-1"
                className="tab d-flex justify-content-center align-items-center"
                style={{ textAlign: "center" }}
              >
                Account Deletion Request
              </label>
              <input id="tab-2" type="radio" name="tab" className="for-pwd" />
              <label htmlFor="tab-2" className="tab text-center"></label>

              <div className="login-form">
                <div className="hr" />
                <div className="sign-in-htm mt-3">
                  <form
                    autoComplete="off"
                    onSubmit={this.submitForm}
                    style={{ background: "none" }}
                  >
                    {/* Email Field */}
                    <div className="input-group form-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fa fa-user"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        autoComplete="new-email"
                        placeholder="Email Id"
                        onChange={this.handleChange}
                        name="Email"
                        value={this.state.Email}
                        className="form-control user"
                        noValidate
                      />
                      <span className="focus-input100"></span>
                      {this.state.formError.Email ? (
                        <div className="error1">
                          {this.state.formError.Email}
                        </div>
                      ) : null}
                    </div>

                    {/* Password Field */}
                    <div
                      className="input-group form-group"
                      style={{
                        marginTop: window.innerWidth >= 768 ? "30px" : "0px",
                      }}
                    >
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fa fa-lock"></i>
                        </span>
                      </div>
                      <input
                        type={this.state.eyeToggle ? "password" : "text"}
                        autoComplete="new-password"
                        onChange={this.handleChange}
                        placeholder="Password"
                        name="Password"
                        value={this.state.Password}
                        className="form-control"
                        noValidate
                      />
                      <span className="focus-input100"></span>
                      <i
                        className={
                          this.state.eyeToggle
                            ? "pi pi-eye eye-design"
                            : "pi pi-eye-slash"
                        }
                        onClick={this.passwordToggle}
                      ></i>
                      {this.state.formError.Password ? (
                        <div className="error1">
                          {this.state.formError.Password}
                        </div>
                      ) : null}
                    </div>

                    <div className="hr" />

                    <div className="group">
                      <button type="submit" className="login-button button">
                        DELETE ACCOUNT
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Confirmation Dialog */}
        <Dialog
          header="Confirm Account Deletion"
          visible={this.state.confirmModal}
          onHide={() => this.setState({ confirmModal: false })}
        >
          <h5 style={{ color: "#3F51B5" }}>Delete Account</h5>
          <p>
            Are you sure you want to permanently delete your account? This
            action cannot be undone.
          </p>
          <div
            className="col-md-12 mt-3 text-center"
            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
          >
            <Button
              label="Cancel"
              className="btn btn-secondary"
              icon="pi pi-times"
              onClick={() => this.setState({ confirmModal: false })}
            />
            <Button
              label="Yes, Delete"
              className="btn btn-danger"
              icon="pi pi-trash"
              onClick={this.handleConfirmDelete}
            />
          </div>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.user.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteUser: (user) => dispatch(userMasterActions.deleteUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccount);
